import { AccordionBlock } from './Accordion'
import { AdsBlock } from './Ads'
import { SimpleAnnouncementBarBlock } from './AnnouncementBar/Simple'
import { BannerBlock } from './Banner'
import { BigNumbersBlock } from './BigNumbers'
import { BlackFridayBlock } from './BlackFriday'
import { BLOCK_NAMES } from './blockNames'
import { BlogContentBlock } from './BlogContent'
import { BlogHeroBlock } from './BlogHero'
import { BlogVideoBlock } from './BlogVideo'
import { ChatbotWhatsappBlock } from './ChatbotWhatsapp'
import { CtaBlock } from './Cta'
import CustomBlock from './Custom/Custom'
import { CustomForm } from './CustomForm'
import { DisclaimerBlock } from './Disclaimer'
import { FgtsLoanSimulatorBlock } from './FgtsLoanSimulator'
import { FooterBlock } from './Footer'
import { HeroBlock } from './Hero'
import { HeroProductBlock } from './HeroProduct'
import { HeroWithCtaBlock } from './HeroWithCta'
import { ListBlock } from './List'
import { LoanSimulatorBlock } from './LoanSimulator'
import { MediaBlock } from './Media/MediaBlock'
import { MediaCardListBlock } from './Media/MediaCardList'
import { MediaCategoryBlock } from './Media/MediaCategory'
import { MediaListBlock } from './Media/MediaList'
import { MediaProductGuidesBlock } from './Media/MediaProductGuides'
import { MediaProductStepByStepBlock } from './Media/MediaProductStepByStep'
import { MediaTestimonialBlock } from './Media/MediaTestimonial'
import { MediaWithBackgroundBlock } from './Media/MediaWithBackground'
import { PartnerSearchListBlock } from './PartnerSearchList'
import { ArticlesGalleryBlock } from './Premium/ArticlesGallery'
import { DisclaimerPremiumBlock } from './Premium/DisclaimerPremium'
import { HeroProductPremiumBlock } from './Premium/HeroProductPremium'
import { ListPremiumBlock } from './Premium/List'
import { MediaWithFormsBlock } from './Premium/MediaWithForms'
import { MiddleButtonBlock } from './Premium/MiddleButton'
import { StepsBlock } from './Premium/Steps'
import { ProductCarousel } from './ProductCarousel'
import { ProductSolutionCarousel } from './ProductSolutionCarousel'
import { SectionAppInstallBlock } from './SectionAppInstall'
import { SocialNetworksBlock } from './SocialNetworks'
import { TabWithListBlock } from './TabWithList'
import { TextBlock } from './Text'

export const BLOCK_MAPPER = {
  [BLOCK_NAMES.hero.default]: HeroBlock,
  [BLOCK_NAMES.hero.product]: HeroProductBlock,
  [BLOCK_NAMES.hero.withCta]: HeroWithCtaBlock,

  [BLOCK_NAMES.list.default]: ListBlock,
  [BLOCK_NAMES.list.features]: ListBlock,
  [BLOCK_NAMES.list.medias]: ListBlock,
  [BLOCK_NAMES.list.panel]: ListBlock,
  [BLOCK_NAMES.list.blog]: ListBlock,
  [BLOCK_NAMES.list.news]: ListBlock,
  [BLOCK_NAMES.list.partner]: ListBlock,

  [BLOCK_NAMES.custom.default]: CustomBlock,
  [BLOCK_NAMES.custom.form]: CustomForm,

  [BLOCK_NAMES.media.default]: MediaBlock,
  [BLOCK_NAMES.media.testimonial]: MediaTestimonialBlock,
  [BLOCK_NAMES.media.category]: MediaCategoryBlock,
  [BLOCK_NAMES.media.list]: MediaListBlock,
  [BLOCK_NAMES.media.productStepByStep]: MediaProductStepByStepBlock,
  [BLOCK_NAMES.media.withBackground]: MediaWithBackgroundBlock,
  [BLOCK_NAMES.media.productGuides]: MediaProductGuidesBlock,
  [BLOCK_NAMES.media.cardList]: MediaCardListBlock,

  [BLOCK_NAMES.banner]: BannerBlock,
  [BLOCK_NAMES.socialNetworks]: SocialNetworksBlock,
  [BLOCK_NAMES.blog.hero]: BlogHeroBlock,
  [BLOCK_NAMES.blog.content]: BlogContentBlock,
  [BLOCK_NAMES.blog.video]: BlogVideoBlock,
  [BLOCK_NAMES.disclaimer]: DisclaimerBlock,
  [BLOCK_NAMES.carousel.product]: ProductCarousel,
  [BLOCK_NAMES.carousel.productSolution]: ProductSolutionCarousel,

  [BLOCK_NAMES.blackFriday]: BlackFridayBlock,
  [BLOCK_NAMES.bigNumbers]: BigNumbersBlock,
  [BLOCK_NAMES.tabWithList]: TabWithListBlock,
  [BLOCK_NAMES.simpleAnnouncementBar]: SimpleAnnouncementBarBlock,
  [BLOCK_NAMES.sectionAppInstall]: SectionAppInstallBlock,
  [BLOCK_NAMES.ads]: AdsBlock,
  [BLOCK_NAMES.accordion]: AccordionBlock,
  [BLOCK_NAMES.cta]: CtaBlock,
  [BLOCK_NAMES.footer]: FooterBlock,
  [BLOCK_NAMES.textBlock]: TextBlock,
  [BLOCK_NAMES.list.searchPartner]: PartnerSearchListBlock,

  [BLOCK_NAMES.loan.default]: LoanSimulatorBlock,
  [BLOCK_NAMES.loan.fgts]: FgtsLoanSimulatorBlock,
  [BLOCK_NAMES.chatbotWhatsapp]: ChatbotWhatsappBlock,

  [BLOCK_NAMES.premium.articlesGallery]: ArticlesGalleryBlock,
  [BLOCK_NAMES.premium.disclaimerPremium]: DisclaimerPremiumBlock,
  [BLOCK_NAMES.premium.heroProductPremium]: HeroProductPremiumBlock,
  [BLOCK_NAMES.premium.list]: ListPremiumBlock,
  [BLOCK_NAMES.premium.mediaWithForms]: MediaWithFormsBlock,
  [BLOCK_NAMES.premium.middleButton]: MiddleButtonBlock,
  [BLOCK_NAMES.premium.steps]: StepsBlock,
} as const
